import { swSettings } from "app/common/services/swSettings";
import {
    FIRST_LAND_PREF_KEY,
    type QuizSplitUseCaseGroup,
} from "app/pages/activation/components/FirstLandModalProvider/constants";
import {
    isAfterTrial,
    isPendingTrialStatus,
    isSI,
    isTrial,
    isWincherUser,
} from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { EParamsName } from "../../types";

import { FirstLandRoutes } from "./constants";
import { routeOnParamExperiment } from "./paramExperimentRouting";
import { resolveQuizLanding } from "./resolveQuizLanding";
import { goReplace } from "./utils";

export const newUserRouting = (urlParams: URLSearchParams) => {
    const isWincher = isWincherUser(swSettings);
    const hasNoIncorrectPackages = !isAfterTrial(swSettings) && !isSI(swSettings);
    const isTrialOrCCinTrial = isTrial(swSettings) || isPendingTrialStatus(swSettings);

    return routeOnParamExperiment(urlParams, {
        triggerParam: EParamsName.NEW_USER,
        isAllowed: isWincher || (hasNoIncorrectPackages && isTrialOrCCinTrial),
        fallback: FirstLandRoutes.WebsiteAnalysisHome,
        skipWhenPreferenceFalse: true,
        preferenceKey: FIRST_LAND_PREF_KEY,
        resolveTarget: () => {
            if (isWincher) {
                return goReplace(FirstLandRoutes.RankTrackerHome);
            }

            const quiz = (swSettings?.user?.customData?.quiz?.UseCase as string) || "";

            return resolveQuizLanding(quiz as QuizSplitUseCaseGroup);
        },
    });
};
